/* ==========================================================================
   Catalogue — floating pills + tabbed modal

   Both pills open the same modal; the second one deep-links to a specific
   panel. Rendering the customer stories once and linking to them beats keeping
   a second copy of the same markup in sync.
   ========================================================================== */

(function () {
  'use strict';

  /* Delegates to the shared lock in catalogue-list.js so stacked overlays do
     not release the page while one underneath is still open. Falls back when
     that script is not on the page. */
  function lockScroll() {
    var api = window.blueprintCatalogue;
    if (api && api.lockScroll) return api.lockScroll();
    document.documentElement.style.overflow = 'hidden';
  }

  function releaseScroll() {
    var api = window.blueprintCatalogue;
    if (api && api.releaseScroll) return api.releaseScroll();
    document.documentElement.style.overflow = '';
  }


  var FOCUSABLE = 'button:not([disabled]), a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function setup(root) {
    if (root.hasAttribute('data-bpc-ready')) return;
    root.setAttribute('data-bpc-ready', 'true');

    var modal = root.querySelector('.bpc-modal');
    if (!modal) return;

    var pills = root.querySelectorAll('[data-bpc-opens]');
    var tabs = Array.prototype.slice.call(modal.querySelectorAll('.bpc-modal-tab'));
    var panels = Array.prototype.slice.call(modal.querySelectorAll('.bpc-panel'));
    var lastFocused = null;
    var activePill = null;

    function selectPanel(name) {
      var match = false;
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-bpc-panel') === name;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        if (on) match = true;
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-bpc-panel') !== name;
      });
      return match;
    }

    function open(panel, pill) {
      lastFocused = document.activeElement;
      activePill = pill || null;

      if (!panel || !selectPanel(panel)) {
        if (tabs.length) selectPanel(tabs[0].getAttribute('data-bpc-panel'));
      }

      modal.classList.add('is-open');
      root.classList.add('is-modal-open');
      lockScroll();
      if (activePill) activePill.setAttribute('aria-expanded', 'true');

      var target = modal.querySelector('.bpc-modal-tab[aria-selected="true"]') || modal.querySelector('.bpc-modal-close');
      if (target) target.focus();
    }

    function close() {
      modal.classList.remove('is-open');
      root.classList.remove('is-modal-open');
      releaseScroll();
      pills.forEach(function (pill) {
        pill.setAttribute('aria-expanded', 'false');
      });
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      lastFocused = null;
      activePill = null;
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        open(pill.getAttribute('data-bpc-opens'), pill);
      });
    });

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        selectPanel(tab.getAttribute('data-bpc-panel'));
      });
      tab.addEventListener('keydown', function (event) {
        var step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        var next = tabs[(i + step + tabs.length) % tabs.length];
        selectPanel(next.getAttribute('data-bpc-panel'));
        next.focus();
      });
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-bpc-close]')) close();
    });

    document.addEventListener('keydown', function (event) {
      if (!modal.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;

      var items = Array.prototype.slice
        .call(modal.querySelectorAll(FOCUSABLE))
        .filter(function (el) {
          return el.offsetParent !== null && el.tabIndex !== -1;
        });
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (tabs.length) selectPanel(tabs[0].getAttribute('data-bpc-panel'));
  }

  function init() {
    document.querySelectorAll('[data-bpc-fab]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
